module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_8023.a2c42e63.png";